<ng-container *transloco="let t">
  <div class="search-input-wrapper">
    <!-- <i-tabler name="search" class="size-4! opacity-80!"></i-tabler> -->
      <i class="iconify size-4.5! opacity-80" data-icon="mdi-light:magnify"></i>
    <input #searchInput [(ngModel)]="value" autocomplete="off" [placeholder]="placeholder || ''" [disabled]="disabled"
           (keyup)="onKeyUp()" (keyup.enter)="setUpdate()" (ngModelChange)="setChange()" (blur)="setBlur()"/>

    <div class="flex flex-row items-center gap-1  ">

      @if(working()) {
      <div class="p-2">
        <mat-progress-spinner [diameter]="20" [mode]="'indeterminate'"></mat-progress-spinner>
      </div>

      } @else if(enableClear && value) {
      <button mat-icon-button (click)="clear(); $event.stopPropagation()" [matTooltip]="t('Clear')">
        <i class="iconify size-4! opacity-80" data-icon="solar:eraser-linear"></i>
      </button>
      }
    </div>

  </div>
</ng-container>
